import React, { useMemo } from 'react';
import { guid } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Right } from '../../../common/icons';
import { useSubMenu } from '../../../hooks/menu';
import { RcHoverTrigger } from '../../../hooks/popper';
import { RcPopover } from '../../../units/popover-wrapper';
import { ListItem } from '../../util/ListItem';
export function DropdownSubMenuWrapper(props) {
  var children = props.children,
      title = props.title,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var subMenu = useSubMenu();

  if (subMenu == null) {
    throw new Error('useSubMenu must be under RcSubMenu');
  }

  var level = subMenu.getLevel();
  var opened = subMenu.getOpened();
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var cls = usePrefixCls('dropdown-submenu', {
    opened: opened
  });
  var itemLineTitleCls = usePrefixCls('dropdown-menu-line-title');
  var submenuHeaderOpenIconCls = usePrefixCls('dropdown-submenu-header-open-icon');
  var submenuContentCls = usePrefixCls('dropdown-submenu-content');
  var popoverCls = usePrefixCls('dropdown-submenu-popover');

  var handleClick = function handleClick(e) {
    if (!disabled) {
      subMenu.setOpened(!opened, opened);
    }

    e.stopPropagation();
  };

  var hidePopover = function hidePopover() {
    !disabled && subMenu.setOpened(false, true);
  };

  var showPopover = function showPopover() {
    !disabled && subMenu.setOpened(true);
  };

  var renderHeader = function renderHeader() {
    return React.createElement(ListItem, {
      prefixCls: "dropdown-submenu",
      onClick: handleClick,
      disabled: disabled
    }, React.createElement("span", {
      className: itemLineTitleCls
    }, title), React.createElement("span", {
      className: submenuHeaderOpenIconCls
    }, React.createElement(Right, null)));
  };

  var renderContent = function renderContent() {
    return React.createElement("div", {
      className: submenuContentCls
    }, children);
  };

  return React.createElement("div", {
    className: cls
  }, React.createElement(RcHoverTrigger, {
    triggerId: triggerId
  }, renderHeader()), React.createElement(RcPopover, {
    show: opened,
    getPopper: renderContent(),
    singleGroupId: String(level),
    placement: "right-start",
    triggerIds: triggerIds,
    refType: "trigger",
    refId: triggerId,
    offset: {
      x: 4,
      y: 0
    },
    className: popoverCls,
    onHide: hidePopover,
    onShow: showPopover
  }));
}